@if (showConfirmDowngrade) {
  <app-confirm-downgrade
    [selectedSubscription]="selectedSubscription?.subscription"
    [currentSubscription]="currentSubscription"
    [isLoading]="isLoading"
    (cancelClick)="cancelDowngrade()"
    (confirmClick)="confirmDowngrade()"
  />
} @else {
  <div class="p-md">
    @if (Features.TMP_ADDON_BANNER | featureFlag) {
      <sb-notice class="mt-sm">
        <p
          [innerHTML]="
            'At the moment, add-ons can\'t be customized through the website. If you\'d like to change your add-ons, please contact us at [email] and we\'ll update your subscription for you.'
              | translate: { email: supportEmail | mailto }
          "
        ></p>
      </sb-notice>
    }

    @if (currentStepIndex !== steps.length) {
      <sb-stepper [currentStep]="currentStepIndex" [steps]="steps" />
    }

    @switch (currentStepIndex) {
      @case (planWizardStep.CHOOSE_PLAN) {
        <choose-plan-card
          class="block px-md lg:px-2xl"
          [forceUpgrade]="forceUpgrade"
          [yearlyBillingToggle]="yearlyBillingToggle"
          [trialExpired]="trialExpired"
        />
      }
      @case (planWizardStep.BILLING_DETAILS) {
        <billing-details-form
          class="p-md"
          [backButtonEnabled]="true"
          [saveLabel]="'Next' | translate"
          (saved)="stepChanged(currentStepIndex + 1)"
          (backPressed)="previousStep()"
        />
      }
      @case (planWizardStep.ORDER_SUMMARY) {
        <order-summary
          class="p-md"
          [yearlyBillingToggle]="yearlyBillingToggle"
          [skipBilling]="skipBilling"
        ></order-summary>
      }
      @case (planWizardStep.BILLING_AND_SUMMARY) {
        <billing-and-summary
          class="block p-md"
          [yearlyBillingToggle]="yearlyBillingToggle"
          [currentStepIndex]="currentStepIndex"
          (billingSaved)="nextStep()"
          (estimatesDone)="estimatesDone = $event"
        />
      }
      @case (planWizardStep.ORDER_COMPLETE) {
        <order-completion (closePressed)="exitWiz()" (backPressed)="previousStep()" class="mx-3.5 mt-4" />
      }
    }
  </div>
}

@if (
  currentStepIndex !== planWizardStep.ORDER_COMPLETE &&
  currentStepIndex !== planWizardStep.BILLING_DETAILS &&
  !showConfirmDowngrade
) {
  <div class="flex justify-end gap-sm p-md">
    @if (currentStepIndex !== planWizardStep.CHOOSE_PLAN) {
      <button sb-button [color]="'secondary'" (click)="previousStep()">
        {{ 'Back' | translate }}
      </button>
    }
    @if (currentStepIndex === planWizardStep.CHOOSE_PLAN) {
      <button sb-button [color]="'primary'" [disabled]="!hasSelectedSubscription" (click)="nextStep()">
        {{ nextBtnLabel }}
      </button>
    }
    @if (currentStepIndex === planWizardStep.BILLING_AND_SUMMARY) {
      <button
        sb-button
        [color]="'primary'"
        type="submit"
        [disabled]="billingAndSummary?.billingDetailsForm?.billingDetailsForm.status === 'PENDING' || !estimatesDone"
        (click)="submitBillingForm()"
        [sbLadda]="isLoading"
      >
        {{ 'Continue to payment' | translate }}
      </button>
    }
    @if (currentStepIndex === planWizardStep.ORDER_SUMMARY && skipBilling) {
      <button sb-button [color]="'primary'" (click)="confirmPlanChange()" [sbLadda]="isSaving">
        {{ 'Confirm change' | translate }}
      </button>
    }
  </div>
}
